import React from 'react'
import PropTypes from 'prop-types'
import { TextFieldStyle } from './ModalFilter.style'

const FloatingFilterComponent = ({ filterParams }) => {
  const { filters, name: list_name, name1: date_from_name, name2: date_to_name } = filterParams

  const getValue = () => {
    if (list_name && Array.isArray(filters[list_name]) && filters[list_name].length > 0) {
      return filters[list_name].join(',')
    }
    if (date_from_name && date_to_name && filters[date_from_name] && filters[date_to_name]) {
      return `${filters[date_from_name]}-${filters[date_to_name]}`
    }
    if (list_name && !Array.isArray(filters[list_name])) {
      return filters[list_name]
    }
    return ''
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <TextFieldStyle disabled value={getValue()} />
    </div>
  )
}

export default FloatingFilterComponent

FloatingFilterComponent.propTypes = {
  filterParams: PropTypes.object
}
